<template>
  <div class="clinic-data page pb-5">
    <div v-if="clinic.quote_value > 0">
      <div class="bg-gray mt-4 mb-4 px-4 py-3" id="free-space-block">
        <div class="row align-items-center">
          <div class="col">
            <label class="form-label">{{ $t('cloud_space') }}</label>
            <div>
              <span>{{ $t('occupied') }}: {{ formatFileSize(clinic.quote_total) }}</span>
              <span class="ml-3">{{ $t('free') }}: {{ formatFileSize(clinic.quote_value - clinic.quote_total) }}</span>
            </div>
          </div>
          <div class="col col-auto">
            <!--          <a class="btn btn-themed btn-themed-squared">{{ $t('ask_for_more') }}</a>-->
          </div>
        </div>
      </div>
      <hr/>
    </div>
    <div class="radio-inline">
      <RadioGroup :options="salaryTypes"
                  :label="$t('salary_accrual_for_personnel_with_assistants')"
                  :showlabel="true"
                  v-model="form.doctor_salaries_type"
                  validationId="doctor_salaries_type"/>
    </div>
    <hr/>
    <div class="radio-inline">
      <RadioGroup :options="salaryTypes"
                  :label="$t('salary_accrual_for_technics')"
                  :showlabel="true"
                  v-model="form.technic_salaries_type"
                  validationId="technic_salaries_type"/>
    </div>
    <hr/>
    <div class="radio-inline">
      <RadioGroup :options="percentTypes"
                  :label="$t('percent_accrual_for_personnel')"
                  :showlabel="true"
                  v-model="form.percent_accrual"
                  validationId="percent_accrual"/>
    </div>
    <hr/>
    <div class="radio-inline">
      <RadioGroup :options="managerPercentTypes"
                  :label="$t('percent_accrual_for_administrator')"
                  :showlabel="true"
                  v-model="form.manager_percent_type"
                  validationId="manager_percent_type"/>
    </div>
    <hr/>
    <div class="radio-inline">
      <RadioGroup :options="salaryAccrualTypes"
                  :label="$t('salary_accrual_with_assistants')"
                  :showlabel="true"
                  v-model="form.salary_accrual"
                  validationId="salary_accrual"/>
    </div>
    <hr/>
    <div v-if="form.salary_accrual === 'payment'">
      <div class="radio-inline">
        <RadioGroup :options="salaryAccrualTypes"
                    :label="$t('technic_salary_accrual')"
                    :showlabel="true"
                    :readonly="form.salary_accrual === 'all'"
                    v-model="form.clinic_additional.technic_salary_accrual"
                    validationId="technic_salary_accrual"/>
      </div>
      <hr/>
    </div>
<!--    <div v-if="rights.includes('laboratories')">-->
<!--      <div class="radio-inline">-->
<!--        <RadioGroup :options="labServicesDeductionOptions"-->
<!--                    :label="$t('logics_on_laboratory_services_deduction')"-->
<!--                    :showlabel="true"-->
<!--                    v-model="form.clinic_additional.laboratory_services_in_salaries_calculation"-->
<!--                    validationId="laboratory_services_in_salaries_calculation"/>-->
<!--      </div>-->
<!--      <hr/>-->
<!--    </div>-->
    <CheckboxGroup :label="$t('deduct_acquiring_from_salary')"
                   :checkboxvalue="1"
                   fid="deduct_acquiring_from_salary"
                   v-model="form.clinic_additional.deduct_acquiring_from_salary"/>

    <transition name="fade"  mode="out-in">
      <div v-if="form.clinic_additional.deduct_acquiring_from_salary" class="ml-5">
        <CheckboxGroup :label="$t('do_not_deduct_acquiring_from_technic_absolute')"
                       :checkboxvalue="1"
                       fid="do_not_deduct_acquiring_from_technic_absolute"
                       v-model="form.clinic_additional.do_not_deduct_acquiring_from_technic_absolute"/>
      </div>
    </transition>

    <CheckboxGroup :label="$t('deduct_warranty_from_salary')"
                   :checkboxvalue="1"
                   fid="deduct_warranty_from_salary"
                   v-model="form.clinic_additional.deduct_warranty_from_salary"/>

    <CheckboxGroup :label="$t('accept_payments_for_nonclosed_visit')"
                   v-if="rights.includes('accept_payments')"
                   :checkboxvalue="1"
                   fid="accept_payments_for_nonclosed_visit"
                   v-model="form.clinic_additional.accept_payments_for_nonclosed_visit"/>

    <hr/>

    <div class="radio-inline">
      <RadioGroup :options="materialsWriteOffTypes"
                  :label="$t('write_off_materials')"
                  :showlabel="true"
                  v-model="form.clinic_additional.materials_write_off"
                  validationId="materials_write_off"/>
    </div>

    <CheckboxGroup :label="$t('prohibit_minus_stocks')"
                   :checkboxvalue="1"
                   fid="prohibit_minus_stocks"
                   v-model="form.clinic_additional.prohibit_minus_stocks">
      <InfoTooltip :text="$t('prohibit_minus_stocks_in_warehouse_documents')"/>
    </CheckboxGroup>

    <CheckboxGroup :label="$t('prohibit_minus_stocks_on_visit_closing')"
                   v-if="form.clinic_additional.materials_write_off === 'on_visit_close'"
                   :checkboxvalue="1"
                   fid="prohibit_minus_stocks_on_visit_closing"
                   v-model="form.clinic_additional.prohibit_minus_stocks_on_visit_closing"/>

    <CheckboxGroup :label="$t('deduct_materials_from_doctor_salary')"
                   v-if="rights.includes('materials')"
                   :checkboxvalue="1"
                   fid="deduct_materials_from_doctor_salary"
                   v-model="form.clinic_additional.deduct_materials_from_doctor_salary"/>

    <hr/>

    <div v-if="egiszOrResultsEnabled">
      <div class="radio-inline">
        <RadioGroup :options="saveTypes"
                    :label="$t('sending_after_save_or_finish')"
                    :showlabel="true"
                    :readonly="form.salary_accrual === 'all'"
                    v-model="form.clinic_additional.sending_after_save_or_finish"
                    validationId="sending_after_save_or_finish"/>
      </div>
    </div>

    <div class="radio-inline">
      <RadioGroup :options="techSupportTypes"
                  :label="$t('techsupport_panel')"
                  :showlabel="true"
                  v-model="form.support_button"
                  validationId="support_button"/>
    </div>
    <hr/>
    <SelectGroup :options="languages"
                 variant="white"
                 :showlabel="true"
                 :null-option="false"
                 :label="$t('program_language')"
                 class="d-inline-block align-middle mb-0 select-200"
                 v-model="form.language"/>
    <div class="mt-3">{{ $t('time_zone') }}: {{ clinic.time_zone }}</div>
    <hr/>
    <SelectGroup :options="intervals"
                 variant="white"
                 :showlabel="true"
                 :translate="false"
                 :nullOption="false"
                 :label="$t('logout_interval_timeout')"
                 class="d-inline-block align-middle mb-0 select-200"
                 v-model="form.logout_timeout"/>
    <hr/>

    <InputGroup :label="$t('months_to_consider_patient_lost')"
                type="number"
                class="d-inline-block select-200"
                v-model="form.activity_status_months"/>

    <SelectGroup :options="permanentPatientOptions"
                 variant="white"
                 :showlabel="true"
                 :translate="true"
                 :nullOption="false"
                 :info-hint="$t('permanent_patients_hint')"
                 :label="$t('which_clients_to_consider_permanent')"
                 class="d-inline-block align-middle select-200"
                 v-model="form.clinic_additional.permanent_patients"/>
    <div>
      <SelectGroup :options="outgoingCallTypes"
                   variant="white"
                   :showlabel="true"
                   :translate="true"
                   :nullOption="false"
                   :label="$t('outgoing_calls_through')"
                   class="d-inline-block align-middle select-200"
                   v-model="form.clinic_additional.outgoing_calls"/>
    </div>
    <hr/>
    <!--    <InputGroup v-model="form.name" :label="$t('clinic_name')"/>-->
    <FileGroup :label="$t('logo')"
               fid="file-logo"
               :filetype="'image'"
               :deletefile="true"
               :labelline="true"
               :required="false"
               @input="file"
               v-model="form.photo"/>
    <hr/>

<!--    <CheckboxGroup :label="$t('show_teeth_general')"-->
<!--                   :checkboxvalue="1"-->
<!--                   fid="show_teeth_general"-->
<!--                   v-model="form.show_teeth_general"/>-->

    <CheckboxGroup :label="$t('show_description_in_forms')"
                   :checkboxvalue="1"
                   fid="show_description_in_forms"
                   v-model="form.show_description_in_forms"/>

<!--    <CheckboxGroup :label="$t('show_complex_materials_for_teeth')"-->
<!--                   v-if="rights.includes('materials')"-->
<!--                   :checkboxvalue="1"-->
<!--                   fid="show_complex_materials_for_teeth"-->
<!--                   v-model="form.clinic_additional.show_complex_materials_for_teeth"/>-->

    <CheckboxGroup :label="$t('automatic_conflict_task_creation')"
                   :checkboxvalue="1"
                   fid="automatic_conflict_task_creation"
                   v-model="form.clinic_additional.automatic_conflict_task_creation"/>

    <CheckboxGroup :label="$t('allow_negative_deposits')"
                   :checkboxvalue="1"
                   fid="allow_negative_deposits"
                   v-model="form.clinic_additional.allow_negative_deposits"/>

    <CheckboxGroup :label="$t('allow_to_make_payment_in_insurance_visits')"
                   v-if="rights.includes('insurance')"
                   :checkboxvalue="1"
                   fid="payments_for_insurance_visits"
                   v-model="form.clinic_additional.payments_for_insurance_visits"/>
    <div class="mt-5">
      <button class="btn btn-themed btn-themed-squared"
              @click="save">
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import FileGroup from '@/components/form/FileGroup'
import RadioGroup from '@/components/form/RadioGroup'
import SelectGroup from "@/components/form/SelectGroup"
import {mapGetters, mapState} from "vuex"
import {
  salaryTypes,
  percentTypes,
  salaryAccrualTypes,
  managerPercentTypes,
  permanentPatientOptions,
  outgoingCallTypes,
  materialsWriteOffTypes,
  labServicesDeductionOptions
} from "@/dictionaries/dictionary"
import { saveLanguage } from "@/services/lang.helper"
import InputGroup from "@/components/form/InputGroup"
import CheckboxGroup from "@/components/form/CheckboxGroup"
import { EloquentService } from "@/services/api/eloquent.api.service"
import { formatFileSize } from "@/extensions/filters/filters"
import { copyObject } from "@/extensions/prototypes/prototypes"
import InfoTooltip from "@/components/parts/general/InfoTooltip.vue"

export default {
  name: "SettingsClinic",
  head() {
    return {
      title: this.$t('clinic_data'),
    }
  },
  components: {
    InfoTooltip,
    CheckboxGroup,
    InputGroup,
    FileGroup,
    RadioGroup,
    SelectGroup,
  },
  data() {
    return {
      permanentPatientOptions,
      materialsWriteOffTypes,
      salaryTypes: Object.values(salaryTypes),
      percentTypes: Object.values(percentTypes),
      outgoingCallTypes,
      techSupportTypes: [
        { id: '0', title: 'turned_off' },
        { id: '1', title: 'turned_on' }
      ],
      saveTypes: [
        { id: 'finish', title: 'finish' },
        { id: 'save', title: 'save' },
      ],
      managerPercentTypes: Object.values(managerPercentTypes),
      salaryAccrualTypes: Object.values(salaryAccrualTypes),
      labServicesDeductionOptions,
      languages: [
        { id: 'russian', title: 'russian' },
        { id: 'kazakh', title: 'kazakh' },
        { id: 'kyrgyz', title: 'kyrgyz' },
        { id: 'uzbek', title: 'uzbek' },
        { id: 'ukrainian', title: 'ukrainian' },
        { id: 'azerbaijani', title: 'azerbaijani' },
        { id: 'english', title: 'english' },
      ],
      intervals: [
        { id: 0, title: this.$t('absent') },
        { id: 60, title: '1 '+this.$t('minute') },
        { id: 300, title: '5 '+this.$t('minutes') },
        { id: 600, title: '10 '+this.$t('minutes') },
        { id: 900, title: '15 '+this.$t('minutes') },
        { id: 1200, title: '20 '+this.$t('minutes') },
        { id: 1800, title: '30 '+this.$t('minutes') },
        { id: 3600, title: '1 '+this.$t('hour') },
        { id: 7200, title: '2 '+this.$t('of_few_hours') },
        { id: 10800, title: '3 '+this.$t('of_few_hours') },
        { id: 14400, title: '4 '+this.$t('of_few_hours') },
        { id: 18000, title: '5 '+this.$t('of_hours') },
      ],
      additional: null
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic,
      rights: state => state.auth.rights,
    }),
    ...mapGetters([
      'getClinicAdditional'
    ]),
    clinicSalaryAccrual() {
      return this.form.salary_accrual
    },
    materialsWriteOffType() {
      return this.form?.clinic_additional?.materials_write_off
    },
    egiszOrResultsEnabled() {
      return this.getClinicAdditional('ask_result_on_saving') === 1 || this.rights.includes('egisz_edit')
    }
  },
  watch: {
    clinic: {
      handler(val) {
        this.form = val
        if(val.photo && val.logo && !this.form.image) {
          this.form.image = val.photo
        }
      },
      immediate: true
    },
    clinicSalaryAccrual(val) {
      if(val === 'all') {
        this.form.clinic_additional.technic_salary_accrual = 'all'
      }
    },
    materialsWriteOffType(val) {
      if(val === 'on_visit_save' && this.form?.clinic_additional) {
        this.form.clinic_additional.prohibit_minus_stocks_on_visit_closing = 0
      }
    }
  },
  mounted() {
    this.additional = copyObject(this.clinic.clinic_additional)
  },
  methods: {
    formatFileSize,
    async save() {
      let formData = new FormData()
      let file = this.form.image
      let data = copyObject(this.form)
      data.image = file || 'delete'
      formData = this.appendFormdata(formData, data)
      if(this.form.clinic_additional.automatic_conflict_task_creation !== this.additional.automatic_conflict_task_creation
          || this.form.clinic_additional.permanent_patients !== this.additional.permanent_patients
          || this.form.clinic_additional.deduct_acquiring_from_salary !== this.additional.deduct_acquiring_from_salary
          || this.form.clinic_additional.do_not_deduct_acquiring_from_technic_absolute !== this.additional.do_not_deduct_acquiring_from_technic_absolute
          || this.form.clinic_additional.deduct_materials_from_doctor_salary !== this.additional.deduct_materials_from_doctor_salary
          || this.form.clinic_additional.deduct_warranty_from_salary !== this.additional.deduct_warranty_from_salary
          || this.form.clinic_additional.accept_payments_for_nonclosed_visit !== this.additional.accept_payments_for_nonclosed_visit
          || this.form.clinic_additional.outgoing_calls !== this.additional.outgoing_calls
          || this.form.clinic_additional.technic_salary_accrual !== this.additional.technic_salary_accrual
          || this.form.clinic_additional.allow_negative_deposits !== this.additional.allow_negative_deposits
          || this.form.clinic_additional.prohibit_minus_stocks !== this.additional.prohibit_minus_stocks
          || this.form.clinic_additional.prohibit_minus_stocks_on_visit_closing !== this.additional.prohibit_minus_stocks_on_visit_closing
          || this.form.clinic_additional.sending_after_save_or_finish !== this.additional.sending_after_save_or_finish
          || this.form.clinic_additional.payments_for_insurance_visits !== this.additional.payments_for_insurance_visits
          || this.form.clinic_additional.materials_write_off !== this.additional.materials_write_off
          || this.form.clinic_additional.laboratory_services_in_salaries_calculation !== this.additional.laboratory_services_in_salaries_calculation
      ) {
        let addFormData = new FormData()
        addFormData.set('clinic_id', this.clinic.id)
        addFormData.set('automatic_conflict_task_creation', this.form.clinic_additional.automatic_conflict_task_creation)
        addFormData.set('deduct_acquiring_from_salary', this.form.clinic_additional.deduct_acquiring_from_salary)
        addFormData.set('do_not_deduct_acquiring_from_technic_absolute', this.form.clinic_additional.do_not_deduct_acquiring_from_technic_absolute)
        addFormData.set('deduct_warranty_from_salary', this.form.clinic_additional.deduct_warranty_from_salary)
        addFormData.set('deduct_materials_from_doctor_salary', this.form.clinic_additional.deduct_materials_from_doctor_salary)
        addFormData.set('accept_payments_for_nonclosed_visit', this.form.clinic_additional.accept_payments_for_nonclosed_visit)
        addFormData.set('permanent_patients', this.form.clinic_additional.permanent_patients)
        addFormData.set('outgoing_calls', this.form.clinic_additional.outgoing_calls)
        addFormData.set('technic_salary_accrual', this.form.clinic_additional.technic_salary_accrual)
        addFormData.set('allow_negative_deposits', this.form.clinic_additional.allow_negative_deposits)
        addFormData.set('prohibit_minus_stocks', this.form.clinic_additional.prohibit_minus_stocks)
        addFormData.set('prohibit_minus_stocks_on_visit_closing', this.form.clinic_additional.prohibit_minus_stocks_on_visit_closing)
        addFormData.set('sending_after_save_or_finish', this.form.clinic_additional.sending_after_save_or_finish)
        addFormData.set('payments_for_insurance_visits', this.form.clinic_additional.payments_for_insurance_visits)
        addFormData.set('materials_write_off', this.form.clinic_additional.materials_write_off)
        addFormData.set('laboratory_services_in_salaries_calculation', this.form.clinic_additional.laboratory_services_in_salaries_calculation)
        await EloquentService.update('clinic_additional', this.clinic.id, addFormData)
      }
      const d = await this.$store.dispatch('saveData', formData)
      if (d.clinic.lang_code !== this.$i18n.locale) {
        saveLanguage(d.clinic.lang_code)
        location.reload()
      } else {
        this.$noty.info(this.$t('success_message'))
      }
      await this.$store.dispatch('init')
    },
    file(val) {
      this.form.image = val
    }
  }
}
</script>

<style scoped lang="scss">
.clinic-data {
  max-width: 600px;
}
.bg-gray {
  border-radius: 5px;
}
</style>
